let ROOTURL = 'https://admin.zhonghaiyy.com';
export const basePath = ROOTURL
export const setAvatar = (ImageId, photoUrl) => {
    if (ImageId) return ROOTURL+ ImageId.replace("./wwwroot","");
    else return photoUrl;
}



// WEBPACK FOOTER //
// ./src/utils/const.js